import React, { useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutUsuario, obtenerHoras, obtenerEstadoHorasHabilitadas } from '../../actions/index.js';
import Semana from '../cardSemana/CardSemana.jsx';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.jsx'; // Importa el componente LoadingSpinner
import './homepage.css';
import NavBarHome from '../NavBarHome/NavBarHome.jsx';
import CrearCliente from '../CrearCliente/CrearCliente.jsx';
import EditarClienteSimple from '../EditarCliente/EditarClienteSimple.jsx';
import ConsultarCliente from '../ConsultarCliente/ConsultarCliente.jsx';
import FeatureTour from '../FeatureTour/FeatureTour.jsx';
import { logger } from '../../utils/logger.js';

// Pasos del tour de funcionalidades nuevas (se muestra la primera vez).
// Subí la versión de storageKey (ts_tour_v2, etc.) para volver a mostrarlo al sumar features.
const TOUR_STEPS = [
  {
    selector: '.btnCargaSemanal',
    title: 'Carga semanal',
    body: 'Cargá las mismas horas en varios días de la semana de una sola vez: elegís los días y se crean todos juntos.',
  },
  {
    selector: '.btnDup',
    title: 'Duplicar una entrada',
    body: '¿Repetís una carga? Tocá "Duplicar" y se precarga igual para copiarla en este día o en otros.',
  },
];

const HomePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(true); // Estado para controlar la carga
  const [mostrarCrearCliente, setMostrarCrearCliente] = useState(false);
  const [mostrarEditarCliente, setMostrarEditarCliente] = useState(false);
  const [mostrarConsultarCliente, setMostrarConsultarCliente] = useState(false);
  const user = useSelector(state => state.usuario);

  useEffect(() => {
    // Cargar los datos necesarios al montar el componente
    const cargarDatos = async () => {
      try {
        await dispatch(obtenerHoras()); // Cargar horas
        await dispatch(obtenerEstadoHorasHabilitadas()); // Cargar estado horas habilitadas
        setLoading(false); // Datos listos: se oculta el spinner de inmediato (sin delay artificial)
      } catch (error) {
        logger.error('Error al cargar los datos:', error);
        setLoading(false); // En caso de error, también cambia el estado de carga a false para evitar que el indicador de carga permanezca para siempre
      }
    };

    
  
    cargarDatos();
  }, [dispatch]); //

// Funciones para manejar el modal de crear cliente
  const handleMostrarCrearCliente = () => {
    setMostrarCrearCliente(true);
  };

  const handleCerrarCrearCliente = () => {
    setMostrarCrearCliente(false);
  };

  const handleClienteCreado = (cliente) => {
    logger.log('Cliente creado exitosamente:', cliente);
    // Aquí podrías actualizar algún estado si necesitas refrescar la lista de clientes
  };

// Funciones para manejar el modal de editar cliente
  const handleMostrarEditarCliente = () => {
    setMostrarEditarCliente(true);
  };

  const handleCerrarEditarCliente = () => {
    setMostrarEditarCliente(false);
  };

  const handleClienteActualizado = (cliente) => {
    logger.log('Cliente actualizado exitosamente:', cliente);
    // Aquí podrías actualizar algún estado si necesitas refrescar la lista de clientes
  };

// Funciones para manejar el modal de consultar cliente
  const handleMostrarConsultarCliente = () => {
    setMostrarConsultarCliente(true);
  };

  const handleCerrarConsultarCliente = () => {
    setMostrarConsultarCliente(false);
  };

// Función para cerrar sesión
  const handleLogout = () => {
    dispatch(logoutUsuario());
    history.push('/login');
  };

// Renderiza el componente
  return (
    <div className="home-page">
      <NavBarHome
        user={user} 
        handleLogout={handleLogout} 
        onCrearCliente={handleMostrarCrearCliente}
        onEditarCliente={handleMostrarEditarCliente}
        onConsultarCliente={handleMostrarConsultarCliente}
      /> {/* Aquí se agrega la NavBarHome */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Semana />
          <FeatureTour storageKey="ts_tour_v1" steps={TOUR_STEPS} />
        </>
      )}
      
      {/* Modal de crear cliente */}
      {mostrarCrearCliente && (
        <CrearCliente 
          onClose={handleCerrarCrearCliente}
          onClienteCreado={handleClienteCreado}
        />
      )}

      {/* Modal de editar cliente */}
      {mostrarEditarCliente && (
        <EditarClienteSimple 
          onClose={handleCerrarEditarCliente}
          onClienteActualizado={handleClienteActualizado}
        />
      )}

      {/* Modal de consultar cliente */}
      {mostrarConsultarCliente && (
        <ConsultarCliente 
          onClose={handleCerrarConsultarCliente}
        />
      )}
    </div>
  );
};

export default React.memo(HomePage);